<script setup lang="ts">
import { tv } from '../tv';

/**
 * A glow in a corner of a screen — v1's blurred blobs: a 176×165 solid color
 * under a 110px blur (Blur/Glow), fixed behind the content. `primary` (the
 * default) is the purple one in the top corner of every screen; `secondary`
 * is the plum one in the bottom-start corner that the sign-in screen adds.
 * Decorative; put it first inside a container with `isolate` so it stays
 * behind that container's content.
 */
const props = withDefaults(defineProps<{
  variant?: 'primary' | 'secondary';
}>(), {
  variant: 'primary',
});

const glow = tv({
  base: 'pointer-events-none fixed -z-10 h-41 w-44 rounded-full blur-glow',
  variants: {
    variant: {
      primary: '-top-18 -right-5 bg-glow-strong',
      secondary: '-bottom-22.5 -left-20 bg-glow-secondary',
    },
  },
});
</script>

<template>
  <div
    :class="glow({ variant: props.variant })"
    aria-hidden="true"
  />
</template>
